import { OuraRing4Logo } from '@jouzen/ecom-components/icons/OuraRing4Logo';
import { InverseHeader } from '@jouzen/ecom-components/layout';
import { usePathname } from 'next/navigation';
import { useRef } from 'react';

import { EventType } from '@/analytics/types';
import HsaFsaIcon from '@/app/[locale]/_components/HomeHero/_heros/common/HsaFsaIcon';
import LandingPageHero from '@/app/components/LandingPage/LandingPageHero';
import { STORE_POP_PATHNAME } from '@/app/consts/pathnames';

const PopHero = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const path = usePathname();

  const handleCtaClick = () => {
    void window.ouraAnalytics.track(EventType.CTAClicked, {
      cta: 'choose your oura ring 4',
      action: 'go_to_wizard',
      location: 'pop hero',
      path,
    });
  };

  return (
    <InverseHeader enter margin="50px">
      <div ref={wrapperRef}>
        <LandingPageHero
          backgroundImage={{
            alt: '',
            srcSet: [
              {
                media: '(max-width: 1023px)',
                src: 'blue-sky/pop/gen4/hero-final.jpg?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.5fp-z=1',
              },
              {
                media: '(min-width: 1024px)',
                src: 'blue-sky/pop/gen4/hero-final.jpg?ar=4:3&fit=crop&crop=focalpoint&fp-x=0.2&fp-y=0.44&fp-z=1.25',
              },
              {
                media: '(min-width: 1200px)',
                src: 'blue-sky/pop/gen4/hero-final.jpg?ar=4:3&fit=crop&crop=focalpoint&fp-x=0.4&fp-y=0.44&fp-z=1.3&exp=-3',
              },
            ],
          }}
          backgroundOverlay={
            <div
              className="size-full max-lg:hidden"
              style={{
                backgroundImage:
                  'linear-gradient(269.93deg, transparent 65.57%, rgba(79, 60, 46, 0.8) 95.52%)',
              }}
            />
          }
          backgroundProps={{
            color: 'sandstone-200',
            gradients: [],
          }}
          bottomIcon={<HsaFsaIcon />}
          copy="pop_gen4_hero_copy"
          copyProps={{
            className: 'max-w-[405px]',
          }}
          cta={{
            fixed: { sm: true, lg: false },
            hidden: { sm: false, lg: false },
            href: `${STORE_POP_PATHNAME}/oura-ring-4/silver`,
            label: 'choose_your_oura_ring_4',
            onClick: handleCtaClick,
          }}
          customEyebrow={
            <OuraRing4Logo className="mb-4" height={27} width={134} />
          }
          data-cy="pop-hero-section"
          textColor="text-sandstone-200"
          title="pop_gen4_hero_title"
          titleProps={{
            emProps: {
              className: 'inline font-light',
            },
            indentation: 'pl-0!',
            typographyProps: {
              className:
                'text-center font-normal leading-tighter md:max-w-[540px] lg:text-left lg:text-[5.556vw] xxl:text-[5rem]',
            },
          }}
        />
      </div>
    </InverseHeader>
  );
};

export default PopHero;
